import { Linkedin, Twitter, Instagram, Youtube } from "lucide-react";

export default function Footer() {
  return (
    <footer className="relative pt-16 pb-10 border-t border-[var(--yg-border)]" data-testid="site-footer">
      <div className="max-w-[1240px] mx-auto px-5 sm:px-8">
        <div className="grid sm:grid-cols-[minmax(0,1.4fr)_minmax(0,1fr)_minmax(0,1fr)] gap-10 sm:gap-14">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 rounded-[10px] overflow-hidden flex items-center justify-center">
                <img src="/logo.png" alt="Yugiq logo" className="w-full h-full object-cover" />
              </span>
              <span className="text-white font-extrabold tracking-[-0.02em] text-[15px]">Yugiq Technologies</span>
            </div>
            <p className="text-[13.5px] text-[var(--yg-text-mute)] leading-relaxed max-w-[380px]">
              An AI technology company. We design websites, build mobile apps, and deploy AI agents &amp; automation that run your business — 24/7.
            </p>
            <address className="mt-5 not-italic text-[13px] text-[var(--yg-text-mute)] leading-relaxed max-w-[320px]" data-testid="footer-address">
              1311, 86, CENTRAL by Crystal Group,<br />
              Andheri–Ghatkopar Link Rd, Mumbai
            </address>
          </div>

          <div>
            <div className="yg-mono text-[10px] tracking-[0.24em] uppercase text-[var(--yg-text-dim)] mb-4">What we do</div>
            <ul className="space-y-2.5 text-[13.5px]">
              <li><a className="text-white/80 hover:text-white transition-colors" href="#capabilities">Website Development</a></li>
              <li><a className="text-white/80 hover:text-white transition-colors" href="#capabilities">App Development</a></li>
              <li><a className="text-white/80 hover:text-white transition-colors" href="#services">AI Agents &amp; Automation</a></li>
              <li><a className="text-white/80 hover:text-white transition-colors" href="/insights">Insights</a></li>
              <li><a className="text-white/80 hover:text-white transition-colors" href="/finus">FINUS · Finance app</a></li>
              <li><a className="text-white/80 hover:text-white transition-colors" href="#portfolio">Our Work</a></li>
              <li><a className="text-white/80 hover:text-white transition-colors" href="#audit">Free AI Audit</a></li>
            </ul>
          </div>

          <div>
            <div className="yg-mono text-[10px] tracking-[0.24em] uppercase text-[var(--yg-text-dim)] mb-4">Say hi</div>
            <ul className="space-y-2.5 text-[13.5px]">
              <li><a className="text-white/80 hover:text-white transition-colors" href="mailto:hello@yugiq.in" data-testid="footer-email">hello@yugiq.in</a></li>
              <li><a className="text-white/80 hover:text-white transition-colors" href="tel:+919702124159" data-testid="footer-phone">+91 97021 24159</a></li>
              <li><a className="text-white/80 hover:text-white transition-colors" href="https://wa.me/919702124159" target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp">WhatsApp us</a></li>
            </ul>
            <div className="mt-5 flex items-center gap-2">
              {[
                { Icon: Linkedin, l: "LinkedIn" },
                { Icon: Twitter, l: "X / Twitter" },
                { Icon: Instagram, l: "Instagram" },
                { Icon: Youtube, l: "YouTube" },
              ].map(({ Icon, l }) => (
                <a
                  key={l}
                  href="#"
                  aria-label={l}
                  data-testid={`social-${l.toLowerCase().replace(/[^a-z]/g,"-")}`}
                  className="w-9 h-9 rounded-[10px] border border-[var(--yg-border-strong)] flex items-center justify-center text-[var(--yg-text-mute)] hover:text-white hover:border-[var(--yg-violet)] transition-all"
                >
                  <Icon className="w-4 h-4" />
                </a>
              ))}
            </div>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-[var(--yg-border)] flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <div className="yg-mono text-[10.5px] tracking-[0.22em] uppercase text-[var(--yg-text-dim)]">
            © {new Date().getFullYear()} Yugiq Technologies · All systems live
          </div>
          <div className="yg-mono text-[10.5px] tracking-[0.22em] uppercase text-[var(--yg-text-dim)]">
            Built for the AI-native decade
          </div>
        </div>
      </div>
    </footer>
  );
}
